import type { FC } from "react"

import { useTranslation } from "react-i18next"
import styled from "styled-components"

import houseImage1 from "~/assets/photo/house-compare-1.jpg"
import houseImage2 from "~/assets/photo/house-compare-2.jpg"

import { ReactComponent as ElectricPole } from "@svg/electric-pole.svg"
import { ReactComponent as SunIcon } from "@svg/sun.svg"

import { DEVICE } from "../../../../constants/device-widths"

const HousesHeader = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  aspect-ratio: 16/4.8;
  min-height: 200px;
  top: 0;
  left: 0;
  position: absolute;
  @media ${DEVICE.tablet} {
    margin-top: 50px;
  }
  @media ${DEVICE.desktop} {
    position: relative;
    aspect-ratio: 3/1;
    overflow: hidden;
    border-radius: 10px;
  }
`

const HouseContainer = styled.div<{ textPosition: string }>`
  width: 100%;
  position: relative;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  h2 {
    color: white;
    font-weight: 500;
    letter-spacing: 2px;
    font-size: var(--step-1);
  }
  div {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    ${(props) => props.textPosition}: 25px;
    top: 15px;
  }
`

export const HouseHero: FC<{ navRef: React.RefObject<HTMLHeadingElement> }> = ({
  navRef,
}) => {
  const { t } = useTranslation()

  return (
    <HousesHeader>
      <HouseContainer textPosition="right">
        <div>
          <h2 ref={navRef}>{t(`doNothing`)}</h2>
          <ElectricPole />
        </div>
        <img src={houseImage1} alt="House 1" />
      </HouseContainer>
      <HouseContainer textPosition="left">
        <div>
          <SunIcon />
          <h2>{t(`goSolar`)}</h2>
        </div>
        <img src={houseImage2} alt="House 2" />
      </HouseContainer>
    </HousesHeader>
  )
}
